import { sql } from "drizzle-orm";

import type { WsFeedPreference } from "@storyboard/web-client";
import { bulkInsert } from "@/db/bulkInsert";
import { feedPreference } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";
import { emitTableUpdates } from "@/models/eventing/TableEventManager";

export async function bulkUpsertFeedPreference(records: WsFeedPreference[]) {
  if (records.length === 0) return;
  const deduped = deduplicateByKeyValue(records, (item) => item.id);
  await bulkInsert(feedPreference, deduped, {
    onConflict: {
      type: "doUpdate",
      target: [feedPreference.id],
      set: {
        handsFreeNotificationPreference: sql`excluded."handsFreeNotificationPreference"`,
        pushNotificationPreference: sql`excluded."pushNotificationPreference"`,
        updatedAt: sql`excluded."updatedAt"`,
        feedId: sql`excluded."feedId"`,
        workspaceMembershipId: sql`excluded."workspaceMembershipId"`,
      },
    },
  });
  emitTableUpdates(["feed_preference"]);
}
